<template>
<div>
    <div v-for="(item,index) in splitedList" :key="index">
        <div>
            <span>
            {{ item }} <br>
            </span>
        </div>
    </div>
</div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
    props:['contactForm'],
    computed:{
        ...mapGetters(['indexData']),
        splitedList: function() {
            return (this.contactForm || "").split("|");
        }
    }
}
</script>
<style lang="">
    
</style>